// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:42:10

export default {
  "id": "survival-sword-battle",
  "slug": "survival-sword-battle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/eb420973c4364dbf9a75ce13590e0aea-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/eb420973c4364dbf9a75ce13590e0aea/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Survival Sword Battle",
      "description": "Survival Sword Battle throws you into a ruthless sword-fighting free-for-all battle where a single hit means defeat. Fight to unlock all 10 character evolutions and boost your speed with each upgrade. Can you dominate the leaderboard and survive the longest?",
      "instructions": "* Move the mouse to guide your character \n* Click left mouse button to Attack \n* Hold right mouse button to Speed Boost",
      "genres": [
        "Agility",
        "Battle"
      ],
      "tags": [
        "battlefield",
        "fighting",
        "multiplayer",
        "survival",
        "sword"
      ]
    },
    "zh-CN": {
      "title": "生存剑斗",
      "description": "生存剑斗将你投入一场残酷的无差别剑战混战，一击即败。战斗解锁所有10个角色进化，并随着每一次升级提升你的速度。你能称霸排行榜并生存最久吗？",
      "instructions": "* 将鼠标移动来引导你的角色\n* 点击鼠标左键进行攻击\n* 按住鼠标右键进行加速冲刺",
      "genres": [
        "敏捷",
        "战斗"
      ],
      "tags": [
        "战场",
        "战斗",
        "多人游戏",
        "生存",
        "剑"
      ]
    },
    "zh-TW": {
      "title": "生存劍戰",
      "description": "生存劍戰將您投入一場無情的劍鬥自由混戰，一擊即敗。奮戰以解鎖所有10種角色進化，並隨著每個升級提升您的速度。您能否稱霸排行榜並存活最久？",
      "instructions": "* 拖移滑鼠以引導角色\n* 鼠標左鍵點擊進行攻擊\n* 持續按住鼠標右鍵以增加速度",
      "genres": [
        "敏捷度",
        "戰鬥"
      ],
      "tags": [
        "戰場",
        "戰鬥",
        "多人遊戲",
        "生存",
        "劍"
      ]
    },
    "zh-HK": {
      "title": "生存劍戰",
      "description": "生存劍戰將你投入一場無情無義的劍鬥自由混戰，一擊即敗。奮戰以解鎖所有10種角色進化，並隨著每個升級提升速度。你能夠佔領領先板，並生存最久嗎？",
      "instructions": "* 移動滑鼠引導角色移動\n* 按左鍵攻擊\n* 按住右鍵以加速提升",
      "genres": [
        "敏捷度",
        "戰鬥"
      ],
      "tags": [
        "戰場",
        "戰鬥",
        "多人遊戲",
        "生存",
        "劍"
      ]
    },
    "ja": {
      "title": "サバイバルソードバトル",
      "description": "サバイバルソードバトルは、一撃で敗北が決まる無情な剣戦自由闘争に引き込んでくれます。全10人のキャラクターの進化を解鎖し、それぞれのアップグレードでスピードを向上させよう。リーダーボードを支配し、最も長く生き残れることができるか？",
      "instructions": "* マウスを移動してキャラクターを操作\n* 左クリックで攻撃\n* 右クリックを長押ししてスピードアップ",
      "genres": [
        "スピード",
        "戦闘"
      ],
      "tags": [
        "バトルフィールド",
        "戦闘",
        "マルチプレイヤー",
        "サバイバル",
        "剣"
      ]
    },
    "ko": {
      "title": "생존 검전투",
      "description": "서바이벌 소ード 배틀은 한 번의 타격이 패배를 의미하는 무慈悲한 칼전투 무법지대로 들어가게 합니다. 모든 10개의 캐릭터 진화를 해금하고, 각 업그레이드마다 속도를 증가시키세요. 랭킹을 차지하고 가장 오래 생존할 수 있을까요?",
      "instructions": "* 마우스를 이동하여 캐릭터를 이동시키세요\n* 왼쪽 마우스 버튼을 클릭하여 공격하세요\n* 오른쪽 마우스 버튼을 눌러 속도 증가하세요",
      "genres": [
        "기동력",
        "전투"
      ],
      "tags": [
        "전장",
        "싸움",
        "멀티플레이어",
        "생존",
        "검"
      ]
    },
    "fr": {
      "title": "Bataille de l'épée de survie",
      "description": "Survival Sword Battle vous jette dans un déchaînement sauvage de bataille d'épées sans pitié où un seul coup signifie la défaite. Combattez pour débloquer toutes les 10 évolutions de personnage et augmentez votre vitesse à chaque mise à niveau. Pouvez-vous dominer le classement et survivre le plus longtemps ?",
      "instructions": "* Déplacez la souris pour guider votre personnage\n* Cliquez sur le bouton gauche de la souris pour Attaquer\n* Maintenez enfoncé le bouton droit de la souris pour Activer un Boost de Vitesse",
      "genres": [
        "Agilité",
        "Combat"
      ],
      "tags": [
        "bataillefields",
        "combat",
        "multijoueur",
        "survie",
        "épée"
      ]
    }
  }
};
